import React, { useEffect, useState } from "react";
import { editarRevenda, obterRevendaPorId } from "../services/api";
import CadastroRevenda from "./CadastroRevenda";
import { useParams, useNavigate } from "react-router-dom";

const EditarRevenda = ({ token }) => {
  const [initialData, setInitialData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await obterRevendaPorId(id, token);
        setInitialData(response.data);
      } catch (error) {
        console.error("Erro ao carregar os dados da revenda:", error);
      }
    };
    fetchData();
  }, [id, token]);

  const handleEditSubmit = async (data) => {
    // Erros sobem para o catch de CadastroRevenda (alert).
    await editarRevenda(id, data, token);
    alert("Revenda atualizada com sucesso!");
    navigate("/revendas");
  };

  if (!initialData) return <div>Carregando...</div>;

  return (
    <CadastroRevenda
      token={token}
      initialData={initialData}
      onSubmit={handleEditSubmit}
      isEdit={true}
    />
  );
};

export default EditarRevenda;
